module.exports = __webpack_public_path__ + "static/SellSheet-f0ef127bb6b9aa350869a1822277ab53.pdf";